'use client'

import React, { PropsWithChildren, use, ReactNode, useMemo, useEffect, useReducer } from 'react'
import { pageReducer, StateContext } from '../context'
import { useSearchParams } from 'next/navigation'
import useSWR from 'swr'
import { msvcProxy } from '../../../../utils'
import { EnvTypes } from '../../../../types/envTypes'

const fetcher = (url: string) => fetch(url).then((res) => res.json())

const PageProvider = ({ children, pagePromise, getEnvConfig }: PropsWithChildren<IPageProvider>) => {
  // setup
  const initialPage = use(pagePromise)
  const initialState = useMemo(
    () => ({
      getEnvConfig,
      theme: 'transparent',
      floatingLogosVisible: false,
      ...initialPage
    }),
    [initialPage, getEnvConfig]
  )
  const [state, dispatch] = useReducer(pageReducer, initialState)

  // get fair from url and request th mscv using the proxy
  const searchParams = useSearchParams()
  const fairQs = searchParams.get('fair')

  const { data: fairData } = useSWR(
    fairQs ? `${msvcProxy(getEnvConfig.NEXT_WEBSITE_URL)}/msvc/v1/shows?crmguid=${fairQs}` : null,
    fetcher,
    { revalidateOnFocus: false }
  )

  useEffect(() => {
    // add the fair data to the page context state
    if (fairQs && fairData && !state?.crmEventData?.id) {
      dispatch({ type: 'SET_CRM_EVENT_DATA', payload: fairData })
    }
  }, [fairData, fairQs, state?.crmEventData?.id])

  return <StateContext.Provider value={{ state, dispatch }}>{children}</StateContext.Provider>
}

interface IPageProvider {
  children: ReactNode
  pagePromise: Promise<Record<string, unknown>>
  getEnvConfig: EnvTypes
}

export default PageProvider
